import { useTranslation } from '@pancakeswap/localization'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { PoolState } from '@/hooks/v3/types'
import { useFeeTierDistribution } from '@/hooks/v3/useFeeTierDistribution'
import { Badge } from '@/components/ui/badge'

export function FeeTierPercentageBadge({
  feeAmount,
  distributions,
  poolState,
}: {
  feeAmount: FeeAmount
  distributions: ReturnType<typeof useFeeTierDistribution>['distributions']
  poolState: PoolState
}) {
  const { t } = useTranslation()

  return (
    <Badge variant="secondary" className={'text-[10px]'}>
      {!distributions || poolState === PoolState.NOT_EXISTS || poolState === PoolState.INVALID
        ? t('Not Created')
        : distributions[feeAmount] !== undefined
        ? `${distributions[feeAmount]?.toFixed(0)}% ${t('Pick')}`
        : t('No Data')}
    </Badge>
  )
}
